module.exports = __webpack_public_path__ + "img/cartao_visa.877a9fea.png";